<template>
  <div class="register-documents">
    <div class="form-container">
      <v-card class="section-card" elevation="0">
        <v-form ref="form" v-model="valid">
          <div class="form-header">
            <div class="step-circle">3</div>
            <h2 class="form-title">อัพโหลดเอกสาร</h2>
          </div>

          <p class="muted mb-4">
            กรุณาอัพโหลดเอกสารที่จำเป็นสำหรับการยืนยันตัวตน
            ข้อมูลทั้งหมดจะถูกเก็บรักษาอย่างปลอดภัย
          </p>

          <v-divider class="mb-4"></v-divider>

          <v-row>
            <!-- อัพโหลดสมุดบัญชี -->
            <v-col cols="12">
              <span class="detail-text"
                ><span class="req">*</span>สมุดบัญชี</span
              >
              <div class="upload-section">
                <div v-if="bankBookPreview" class="preview-wrapper">
                  <v-img
                    :src="bankBookPreview"
                    class="preview-image"
                    contain
                    max-height="200"
                  />
                  <v-btn
                    icon
                    small
                    class="remove-btn"
                    @click="removeBankBook"
                  >
                    <v-icon color="white" size="20">mdi-close</v-icon>
                  </v-btn>
                </div>
                <div v-else class="upload-placeholder" @click="triggerBankBookInput">
                  <v-icon size="48" color="#9ca3af">mdi-file-image-outline</v-icon>
                  <span class="upload-text">คลิกเพื่ออัพโหลดสมุดบัญชี</span>
                  <span class="upload-hint">รองรับไฟล์ JPG, PNG (สูงสุด 5MB)</span>
                </div>
                <input
                  ref="bankBookInput"
                  type="file"
                  accept="image/*"
                  style="display: none"
                  @change="handleBankBookChange"
                />
              </div>
            </v-col>

            <!-- อัพโหลดบัตรประจำตัว -->
            <v-col cols="12">
              <span class="detail-text"
                ><span class="req">*</span>บัตรประจำตัวประชาชน</span
              >
              <div class="upload-section">
                <div v-if="idCardPreview" class="preview-wrapper">
                  <v-img
                    :src="idCardPreview"
                    class="preview-image"
                    contain
                    max-height="200"
                  />
                  <v-btn
                    icon
                    small
                    class="remove-btn"
                    @click="removeIdCard"
                  >
                    <v-icon color="white" size="20">mdi-close</v-icon>
                  </v-btn>
                </div>
                <div v-else class="upload-placeholder" @click="triggerIdCardInput">
                  <v-icon size="48" color="#9ca3af">mdi-file-image-outline</v-icon>
                  <span class="upload-text">คลิกเพื่ออัพโหลดบัตรประจำตัวประชาชน</span>
                  <span class="upload-hint">รองรับไฟล์ JPG, PNG (สูงสุด 5MB)</span>
                </div>
                <input
                  ref="idCardInput"
                  type="file"
                  accept="image/*"
                  style="display: none"
                  @change="handleIdCardChange"
                />
              </div>
            </v-col>

            <!-- ปุ่ม -->
            <v-col cols="12" class="mt-3 d-flex justify-space-between">
              <v-btn class="btn-secondary" height="40" @click="handleBack">
                ย้อนกลับ
              </v-btn>
              <v-btn class="btn-primary" height="40" @click="handleNext">
                ถัดไป
              </v-btn>
            </v-col>
          </v-row>
        </v-form>
      </v-card>
    </div>
  </div>
</template>

<script>
import swalAlert from "@/services/alert/swalServices";

export default {
  name: "RegisterDocuments",
  props: {
    value: {
      type: Object,
      default: () => ({
        bankBookFile: null,
        idCardFile: null,
      }),
    },
  },

  data() {
    return {
      valid: false,
      form: {
        bankBookFile: this.value.bankBookFile || null,
        idCardFile: this.value.idCardFile || null,
      },
      bankBookPreview: null,
      idCardPreview: null,
    };
  },

  methods: {
    handleBack() {
      this.$emit("input", { ...this.form });
      this.$emit("back");
    },
    handleNext() {
      if (!this.form.bankBookFile) {
        swalAlert.Error("กรุณาอัพโหลดสมุดบัญชี");
        return;
      }
      if (!this.form.idCardFile) {
        swalAlert.Error("กรุณาอัพโหลดบัตรประจำตัวประชาชน");
        return;
      }
      this.$emit("next", { ...this.form });
    },
    triggerBankBookInput() {
      this.$refs.bankBookInput?.click();
    },
    triggerIdCardInput() {
      this.$refs.idCardInput?.click();
    },
    handleBankBookChange(event) {
      const file = event.target.files?.[0];
      if (!file) return;

      if (!file.type.startsWith("image/")) {
        swalAlert.Error("กรุณาเลือกไฟล์รูปภาพเท่านั้น");
        event.target.value = "";
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        swalAlert.Error("ขนาดไฟล์ต้องไม่เกิน 5 MB");
        event.target.value = "";
        return;
      }

      if (this.bankBookPreview && this.bankBookPreview.startsWith("blob:")) {
        URL.revokeObjectURL(this.bankBookPreview);
      }

      this.form.bankBookFile = file;
      this.bankBookPreview = URL.createObjectURL(file);
      event.target.value = "";
    },
    handleIdCardChange(event) {
      const file = event.target.files?.[0];
      if (!file) return;

      if (!file.type.startsWith("image/")) {
        swalAlert.Error("กรุณาเลือกไฟล์รูปภาพเท่านั้น");
        event.target.value = "";
        return;
      }

      if (file.size > 5 * 1024 * 1024) {
        swalAlert.Error("ขนาดไฟล์ต้องไม่เกิน 5 MB");
        event.target.value = "";
        return;
      }

      if (this.idCardPreview && this.idCardPreview.startsWith("blob:")) {
        URL.revokeObjectURL(this.idCardPreview);
      }

      this.form.idCardFile = file;
      this.idCardPreview = URL.createObjectURL(file);
      event.target.value = "";
    },
    removeBankBook() {
      if (this.bankBookPreview && this.bankBookPreview.startsWith("blob:")) {
        URL.revokeObjectURL(this.bankBookPreview);
      }
      this.form.bankBookFile = null;
      this.bankBookPreview = null;
      if (this.$refs.bankBookInput) {
        this.$refs.bankBookInput.value = "";
      }
    },
    removeIdCard() {
      if (this.idCardPreview && this.idCardPreview.startsWith("blob:")) {
        URL.revokeObjectURL(this.idCardPreview);
      }
      this.form.idCardFile = null;
      this.idCardPreview = null;
      if (this.$refs.idCardInput) {
        this.$refs.idCardInput.value = "";
      }
    },
  },

  watch: {
    value: {
      deep: true,
      immediate: true,
      handler(v) {
        if (!v) return;
        this.form = { ...this.form, ...v };
        if (v.bankBookFile && v.bankBookFile instanceof File) {
          if (this.bankBookPreview?.startsWith?.("blob:")) {
            URL.revokeObjectURL(this.bankBookPreview);
          }
          this.bankBookPreview = URL.createObjectURL(v.bankBookFile);
        }
        if (v.idCardFile && v.idCardFile instanceof File) {
          if (this.idCardPreview?.startsWith?.("blob:")) {
            URL.revokeObjectURL(this.idCardPreview);
          }
          this.idCardPreview = URL.createObjectURL(v.idCardFile);
        }
      },
    },
  },

  beforeDestroy() {
    if (this.bankBookPreview && this.bankBookPreview.startsWith("blob:")) {
      URL.revokeObjectURL(this.bankBookPreview);
    }
    if (this.idCardPreview && this.idCardPreview.startsWith("blob:")) {
      URL.revokeObjectURL(this.idCardPreview);
    }
  },
};
</script>

<style scoped>
.register-documents {
  padding-bottom: 90px;
}
.form-container {
  max-width: 700px;
  margin: 0 auto;
  width: 100%;
  padding: 0 16px;
}
.form-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}
.step-circle {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background-color: #333;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 600;
  font-size: 15px;
}
.form-title {
  font-size: 18px;
  font-weight: 700;
  color: #111827;
  font-family: "Noto Sans Thai", system-ui, Arial, sans-serif;
}
.req {
  color: #e11d48;
  margin-right: 4px;
}
.section-card {
  padding: 24px;
  background: #fff;
  border: 1px solid #f1f5f9;
  border-radius: 12px;
  box-shadow: 0 4px 12px rgba(2, 6, 23, 0.06);
}
.section-card :deep(p.muted) {
  text-align: left !important;
  line-height: 1.6;
  color: #4b5563;
  margin-bottom: 16px;
}
.detail-text {
  display: block;
  font-size: 14px;
  font-weight: 400;
  color: #1f2a39;
  line-height: 1.4;
  margin-bottom: 8px;
}
.upload-section {
  margin-bottom: 16px;
}
.upload-placeholder {
  border: 2px dashed #d1d5db;
  border-radius: 8px;
  padding: 32px 16px;
  text-align: center;
  cursor: pointer;
  transition: all 0.2s;
  background: #f9fafb;
}
.upload-placeholder:hover {
  border-color: #F4811F;
  background: #fff5f0;
}
.upload-text {
  display: block;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  margin-top: 8px;
}
.upload-hint {
  display: block;
  font-size: 12px;
  color: #6b7280;
  margin-top: 4px;
}
.preview-wrapper {
  position: relative;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  background: #f9fafb;
}
.preview-image {
  width: 100%;
  display: block;
}
.remove-btn {
  position: absolute;
  top: 8px;
  right: 8px;
  background: rgba(0, 0, 0, 0.6) !important;
  border-radius: 50%;
  width: 32px;
  height: 32px;
  min-width: 32px;
}
.remove-btn:hover {
  background: rgba(0, 0, 0, 0.8) !important;
}
.btn-primary {
  background: #F4811F !important;
  color: #fff !important;
  border-radius: 8px !important;
}
.btn-secondary {
  background: #e5e7eb !important;
  color: #111827 !important;
  border-radius: 8px !important;
}
</style>
